export const ADMIN_TOKEN_UPDATED = 'ADMIN_TOKEN_UPDATED';

export const customerTags = [
  '{{First Name}}',
  '{{Last Name}}',
  '{{Make}}',
  '{{Model}}',
  '{{Year}}',
  '{{Vin}}',
  '{{Planned Date}}',
  '{{Service Center Name}}',
  // '{{Clone}}',
  '{{Shortlink}}',
  '{{Phone}}',
];
